import React from "react";
import "./MeetVisionaries.css";

const MeetVisionaries = () => {
  const members = [
    {
      name: "Manish Kumar",
      role: "Director",
      image: "/assets/images/team/member1.jpg",
    },
    {
      name: "Manish Kumar",
      role: "Director",
      image: "/assets/images/team/member2.jpg",
    },
    {
      name: "Manish Kumar",
      role: "Director",
      image: "/assets/images/team/member1.jpg",
    },
    {
      name: "Manish Kumar",
      role: "Director",
      image: "/assets/images/team/member2.jpg",
    },
  ];

  return (
    <section className="visionaries-section" style={{ position: "relative" }}>
      <img
        className="visionary-background-img"
        src="/assets/images/About_page/Vector2.png"
        alt="Background"
      />
      <div className="visionaries-container about-All Onlybottom-border">
        <h1>Meet Our Visionaries</h1>
        <h2>Leaders Who Inspire Confidence</h2>
        <h4>
          Behind Clybourne is a team of experts with decades of experience in
          business valuation and<br></br> technology. Together, they ensure you
          get insights that matter.
        </h4>

        <div className="visionaries-cards">
          {members.map((member, index) => (
            <div className="visionary-card" key={index}>
              <div
                className="visionary-photo"
                style={{ backgroundImage: `url(${member.image})` }}
              ></div>

              <h3 className="visionary-name">{member.name}</h3>
              <h3 className="visionary-role">{member.role}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MeetVisionaries;
